var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "setting_select" }, [
    _c("span", { staticClass: "schedule_kinds", style: _vm.style }),
    _vm._v(" "),
    _c("span", { staticClass: "ico_cafe ico_arrow" }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "txt_selected", attrs: { for: "category-select" } },
      [_vm._v(_vm._s(_vm._selectedCategory.name))]
    ),
    _vm._v(" "),
    _c(
      "select",
      {
        staticClass: "select_calendar",
        attrs: { id: "category-select", title: "캘린더보기" },
        on: { change: _vm.onCategoryChange },
      },
      _vm._l(_vm.categories, function (category) {
        return _c("category", {
          attrs: {
            id: category.categoryId,
            name: category.name,
            selected: _vm.selectedCategory === category.categoryId,
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }